import indexedDB from '@/db/index';
import Api from '@/api/index'

const Execution = {
  namespaced: true,

  state: {
    all_executions: [],
    execution_date: null,
    department_id: null,
    
    exec_model_1: {
      employees: []
    },
    exec_model_2: {},

    current_execution: {
      job_interval:{
        
      },
      all_times: [], // array de +31 posicoes (7 as 17 tem 31 posicoes)
      all_times_obj: [], // array de +31 posicoes (7 as 17 tem 31 posicoes)
      comments: []
    },
    exec_model_2: {},

    current_execution: {},
    current_time: null,
    current_time_idx: null,
    categories: []
  },
  getters: {
    getCurrentTime: state => state.current_time,
    getExecutionDate: state => state.execution_date
  },
  mutations: {
    setGradeTime(state, data){
      let {employee_idx, employee_ref, time_idx, grade} = data
      let emp = state.current_execution.employees.find(e=> e.local_ref == employee_ref)
      emp.grade_time[time_idx] = grade
      state.current_execution.employees.splice(employee_idx, 1, {...emp})
      // state.current_execution.employees[employee_idx].grade_time[time_idx] = grade
    },
    setGradeTimeModel2(state, data) {
      let {category_idx, category_id, time_idx, grade} = data
      let emp = state.current_execution.categories.find(e=> e.id == category_id)
      emp.grade_time[time_idx] = grade
      state.current_execution.categories.splice(category_idx, 1, {...emp})
    },
    setCurrentTime(state, time) {
      state.current_time = time;
    },
    setCurrentTimeIdx(state, idx) {
      state.current_time_idx = idx;
    },
    setExecutionInterval(state, job_interval){
      state.current_execution = {
        ...state.current_execution,
        job_interval
      }
    },
    setExecutionModel1(state, exec={}){
      state.current_execution = {
        ...state.exec_model_1,
        ...state.current_execution,
        ...exec,
      }
    },
    setExecutionModel2(state, exec={}){
      state.current_execution = {
        ...state.current_execution,
        ...exec,
      }
    },
    setAllExecutions(state, executions) {
      state.all_executions = [...executions];
    },
    pushToAllExecutions(state, execution) {
      state.all_executions.push({...execution});
    },
    updateDateExec(state, date) {
      state.execution_date = date;
    },
    updateExecDepId(state, id) {
      state.department_id = id;
    },
    clearCurrentExecution(state) {
      state.current_execution = {
        job_interval:{
          start: '07:00',
          end: '17:00',
        },
        all_times: [],
        all_times_obj: [],
        comments: []
      }
    },
    updateJobInterval(state, job_interval) {
      state.current_execution.job_interval = {
        ...state.current_execution.job_interval,
        ...job_interval
      }
    },
    pushComment(state, comment) {
      state.current_execution.comments.unshift({...comment})
    },
    updateEmployee(state, employee) {
      let idx = state.current_execution.employees.findIndex(e => e.local_ref == employee.local_ref)
      state.current_execution.employees.splice(idx, 1, {...employee})
    }
  },
  actions: {
    updateEmployee({commit, dispatch}, employee) {
      commit('updateEmployee', employee);
      dispatch('updateLocalExecution');
    },
    pushComment({commit, dispatch}, comment) {
      commit('pushComment', comment);
      console.log({comment})
      dispatch('updateLocalExecution')
    },
    updateJobInterval({commit}, job_interval) {
      commit('updateJobInterval', job_interval);
    },
    updateExecDepId(context, id) {
      context.commit('updateExecDepId', id);
    },
    updateDateExec(context, date) {
      context.commit('updateDateExec', date);
    },
    setExecution(context, exec) {
      // context.commit("setExecution", exec);
    },
    setGradeTime(context, data) {
      context.commit('setGradeTime', data);
      context.dispatch('updateLocalExecution');
    },
    setGradeTimeModel2(context, data) {
      context.commit('setGradeTimeModel2', data);
      context.dispatch('updateLocalExecution');
    },
    index(context, params) {
      Api.Execution.index({...params}).then(r => r.data).then(executions => {
        context.commit('setAllExecutions', executions);
      }).catch(error => {
        console.log(error);
      });
    },
    async create(context, {execution, data}) {
      let notification = {};
      let prep_exec = {
        department_id: context.state.department_id,
        date: context.state.execution_date,
        started_at: new Date(),
        kind: data.kind,
        name: data.name,
        user_id: 1,
        job_interval: context.state.current_execution.job_interval
      };
      if (prep_exec.kind == 'model_1') {
          context.state.exec_model_1.employees.map(emp => {
          if (emp.outsourced == false) {
            emp.company_name = 'Gerdau'
          }
        })
        prep_exec = {
          ...prep_exec,
          employees: [...context.state.exec_model_1.employees]
        }
      } else if (prep_exec.kind == 'model_2') {
        let categories = await Api.Category.index()
        categories = categories.data
        prep_exec = {
          ...prep_exec,
          categories: [...categories]
        }
      };
      Api.Execution.create(prep_exec).then(r => r.data).then(r => {
        context.commit('pushToAllExecutions', r);
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
        return true;
      }).catch(error => {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`;
        console.log(error);
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      });
    },
    async showLocalExecution(context, execution_id) {
      try {
        let exec = await indexedDB.LocalExecution.getOneExecution(execution_id)
          if (!exec) {
            exec = await Api.Execution.show(execution_id);
            let {json_attributes, ...ex} = exec.data
            exec = {...ex, ...json_attributes};
            await indexedDB.LocalExecution.createExecution(exec);
          }
          if (exec.kind == 'model_1') {
            context.commit('setExecutionModel1', exec)
          } else {
            context.commit('setExecutionModel2', exec)
          }
          await context.dispatch('Category/index', {}, {root: true})
          return exec;
      } catch (error) {
        throw error;
      }
    },
    updateLocalExecution(context) {
      indexedDB.LocalExecution.updateOneExecution(context.state.current_execution).then(execution => {
        console.log({execution});
      }).catch(error => {
        console.log(error);
      });
    },
    async endExecution(context, execution) {
      let notification = {};
      try {
        context.state.current_execution.done_at = new Date();
        await Api.Execution.update(context.state.current_execution);
        await indexedDB.LocalExecution.updateOneExecution(context.state.current_execution);
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
      } catch (error) {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`;
        throw error;
      } finally {
        context.dispatch('Notification/add', notification, {root: true})
      }
    }
  }
};

export default Execution;
